import React from 'react';
import { Card, Statistic } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const KPICard = ({ title, value, prefix, suffix, icon, color, change, loading }) => {
  return (
    <Card bordered={false} style={{ borderRadius: 8 }} loading={loading}>
      <Statistic
        title={title}
        value={value}
        prefix={prefix || (icon && <span style={{ color: color || '#E8192C' }}>{icon}</span>)}
        suffix={suffix}
        valueStyle={{ color: color || '#1a1a2e', fontWeight: 600 }}
      />
      {change !== undefined && (
        <div style={{ marginTop: 8, fontSize: 13 }}>
          {change >= 0 ? (
            <span style={{ color: '#52c41a' }}>
              <ArrowUpOutlined /> {change}%
            </span>
          ) : (
            <span style={{ color: '#ff4d4f' }}>
              <ArrowDownOutlined /> {Math.abs(change)}%
            </span>
          )}
          <span style={{ color: '#999', marginLeft: 8 }}>vs ayer</span>
        </div>
      )}
    </Card>
  );
};

export default KPICard;
